<template>
  <div class="login">
    <div class="login-bgc-top">
      <img src="@/assets/image/login/bgc-top-l.png" />
    </div>
    <div class="FormSubmit">
      <van-form ref="form" @submit="onSubmit">
        <van-field
          class="iconfont icon-shoujihao1"
          v-model="tel"
          clearable
          name="tel"
          :rules="userTel"
          placeholder="请输入姓名"
        />
        <van-field
          class="iconfont icon-shoujihao1"
          v-model="pass"
          type="password"
          clearable
          :rules="password"
          placeholder="请输入密码"
        />
        <van-field
          v-model="code"
          center
          ref="yanzhengCode"
          :rules="userMsg"
          clearable
          class="iconfont icon-yanzhengyanzhengma"
          placeholder="请输入图形验证码"
        >
          <template #button>
            <!-- <van-button
              type="primary"
              size="small"
              class="getCode"
              @click="sendCode"
              :disabled="ifdisabled"
              native-type="button"
            >
              {{ codeMsg }}
            </van-button> -->
            <drawCode :imgurl="imgurl" @getCodeFn="getCodeFn" />
          </template>
        </van-field>
        <div class="login-btn">
          <van-button block type="primary" native-type="submit"
            ><span style="fontsize: px">登&nbsp;录</span>
          </van-button>
        </div>
        <div class="text-box">
          <div class="text-box-no">没有帐号？</div>
          <div class="text-box-go" @click="$router.push('register')">
            立即注册
          </div>
          <div class="text-box-paws" @click="forgotPassword">
            忘记密码
            <!-- $router.push('password') -->
          </div>
        </div>
      </van-form>
    </div>

    <!-- <div class="login-bgc-bottom">
      <img src="@/assets/image/login/bgc-bottom.png">
    </div> -->
    <van-overlay :show="showFlag" @click="showFlag = false">
      <div class="wrapper">
        <div class="block" @click.stop>
          <div class="title_box">
            <img class="tiopsImg" src="../../assets/image/login/tiops.png" />
            <div class="font_title">
              <van-icon size="18px" color="#faad14" name="warning" />
              <span>提示</span>
            </div>
            <van-icon class="closeOff" @click="showFlag = false" name="cross" />
          </div>
          <div class="sercive">
            <p class="one_sercive">如需修改密码，请联系工作人员</p>
            <div class="code_sercive">
              <!-- <img :src="cusSercive.qrcode" /> -->
              <van-image class="qrcode" :src="cusSercive.qrcode" />
              <span class="sp1 sp"></span>
              <span class="sp2 sp"></span>
              <span class="sp3 sp"></span>
              <span class="sp4 sp"></span>
            </div>
            <div class="font">工作人员微信二维码</div>
            <div class="info_sercive">
              <div class="info_item">
                <van-icon class="imgIcon" name="phone" />
                <span>{{ cusSercive.tel }}</span>
              </div>
              <div class="info_item">
                <!-- <van-icon  name="phone" /> -->
                <img class="imgIcon" src="../../assets/image/login/email.png" />
                <span>{{ cusSercive.email }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import drawCode from "../../components/drawCode/index.vue";
export default {
  name: "login",
  components: {
    drawCode,
  },
  data() {
    return {
      tel: "",
      sms: "",
      pass: "",
      code: "",
      uniqid: "",
      imgurl: "",
      showFlag: false,
      cusSercive: {},
      ifdisabled: false,
      codeNum: 60,
      codeMsg: "获取验证码",
      count: "",
      userTel: [
        {
          required: true,
          message: "请输入姓名",
          trigger: "onChange",
        },
        // {
        //   validator: (value) => {
        //     return /^1[23456789]\d{9}$/.test(value);
        //   },
        //   message: "手机号格式错误，请检查！",
        // },
      ],
      password: [
        {
          required: true,
          message: "请输入密码",
          trigger: "onChange",
          //onBlur
        },
      ],

      userMsg: [
        {
          required: true,
          message: "请输入验证码",
          trigger: "onChange",
        },
        // {
        //   validator: (value) => {
        //     // return /^\d{6}$/.test(value);
        //   },
        //   message: "验证码格式错误，请检查！",
        // },
      ],
    };
  },
  created() {
    this.getCodeFn();
    this.serviceFn();
  },
  methods: {
    // 获取短信验证码
    async sendCode() {
      // 验证手机号格式是否正确
      if (!this.tel) {
        this.$toast("请输入手机号！");
        return;
      }
      if (!this.userTel[1].validator(this.tel)) return;
      //发送请求
      const { data: data } = await this.$http.post("system/sms", {
        phone: this.tel,
        type: "LOGIN",
      });
      if (data.code === 200) {
        this.$toast("验证码已发送！");
        // 禁用按钮
        this.ifdisabled = true;
        // 倒计时
        this.count = this.codeNum;
        let timer = setInterval(() => {
          if (this.count > 1 && this.count <= this.codeNum) {
            this.count--;
            this.codeMsg = `重新发送(${this.count})`;
          } else {
            // 判断什么时候停止定时器
            clearInterval(timer);
            this.codeMsg = "获取验证码";
            this.ifdisabled = false;
            this.count = "";
          }
        }, 1000);
      } else {
        this.$toast(data.message);
      }
    },
    //登录
    async onSubmit() {
      const { data: data } = await this.$http.post("auth/login", {
        username: this.tel, //手机号
        password: this.pass, //验证码
        code: this.code,
        uniqid: this.uniqid,
      });
      if (data.code == 200) {
        localStorage.setItem("token", data.data.access_token);
        // this.getMeApi();
        this.$router.push("/homeTopic");
        window.location.reload();
      }
    },
    //获取用户信息 判断是否认证
    async getMeApi() {
      const { data: data } = await this.$http.post("auth/me");
      localStorage.setItem("information", JSON.stringify(data.data));
      if (data.data.doctor_status == 0) {
        this.$router.push("certification");
      } else {
        this.$toast(data.message);
        this.$router.push("/homeTopic");
        window.location.reload();
      }
    },
    async getCodeFn() {
      let { data: res } = await this.$http.get("auth/captcha");
      if (res.code === 200) {
        this.imgurl = res.data.image;
        this.uniqid = res.data.uniqid;
      }
    },
    forgotPassword() {
      this.serviceFn();
      this.showFlag = true;
    },
    async serviceFn() {
      let { data: res } = await this.$http.get("auth/customer-service");
      if (res.code === 200) {
        this.cusSercive = res.data;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.login {
  height: 100vh;
  position: relative;
  overflow: hidden;

  .login-bgc-top {
    position: relative;
    top: 0;
    left: 0;
    width: 306px;
    height: 241px;
  }

  .van-field__control {
    font-size: 16px;
    margin-left: 15px;
  }
  .situLogo {
    margin: 40px auto;
    width: 218px;
    height: 108px;
  }
  .getCode {
    // border-radius: 10px;
    background-color: #ea260e;
    border: 0.02667rem solid #ea260e;
    background: linear-gradient(90deg, #ea260e 0%, #f86b05 100%) !important;
  }
  .FormSubmit {
    margin-top: 10px;
  }
  .login-btn {
    margin-top: 50px;
    padding: 0 30px;
    /deep/ .van-button--primary {
      background-color: #04b5c4;
      border: 0.02667rem solid #04b5c4;
      background: #04b5c4 !important;
    }
  }

  .footCar {
    position: fixed;
    bottom: 0px;
    right: 0px;
  }

  .text-box {
    display: flex;
    padding: 0 30px;
    justify-content: flex-end;
    margin-top: 13px;
    font-size: 13px;
    .text-box-go {
      color: #ef3f0b;
    }
    .text-box-no {
      color: #333;
    }
  }

  .login-bgc-bottom {
    // position: relative;
    // bottom: -4px;
    // right: 0px;

    position: fixed;
    bottom: -4px;
    right: 0px;
    width: 100%;
    // height: 109px;
  }
  .text-box-paws {
    color: blue;
    margin-left: 10px;
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .block {
    background-color: #fff;
    // margin: 0 10px;
    width: 289px;
    border-radius: 12px;
    position: relative;
    .title_box {
      width: 289px;
      height: 56px;
      background: linear-gradient(180deg, #dbfff7 0%, #ffffff 100%);
      border-radius: 12px 12px 0px 0px;
      .font_title {
        width: 289px;
        height: 56px;
        position: absolute;
        z-index: 1;
        top: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          font-size: 16px;
          font-weight: bold;
          color: #393939;
          margin-left: 6px;
        }
      }
      .closeOff:hover {
        background: #3333;
      }
      .closeOff {
        position: absolute;
        z-index: 1;
        top: 10px;
        right: 10px;
        cursor: pointer;
        border-radius: 50%;
        font-size: 20px;
      }
    }
    .sercive {
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 17px 21px 22px 21px;
      .one_sercive {
        font-size: 14px;
        font-weight: 500;
        color: #393939;
      }
      .font {
        font-size: 14px;
        font-weight: 400;
        color: #393939;
        line-height: 30px;
        transform: skewX(-5deg);
        margin-top: 4px;
      }
      .code_sercive {
        width: 105px;
        height: 105px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        margin-top: 28px;
        .qrcode {
          width: 85px;
          height: 85px;
        }
        .sp {
          width: 30px;
          height: 30px;
          position: absolute;
          display: inline-block;
        }
        .sp1 {
          border-top: 1px solid #61c7f6;
          border-left: 1px solid #61c7f6;
          top: 0px;
          left: 0px;
          border-radius: 10px 0 0 0;
        }
        .sp2 {
          border-top: 1px solid #61c7f6;
          border-right: 1px solid #61c7f6;
          top: 0px;
          right: 0px;
          border-radius: 0 10px 0 0;
        }
        .sp3 {
          border-bottom: 1px solid #61c7f6;
          border-right: 1px solid #61c7f6;
          bottom: 0px;
          right: 0px;
          border-radius: 0 0 10px 0;
        }
        .sp4 {
          border-bottom: 1px solid #61c7f6;
          border-left: 1px solid #61c7f6;
          bottom: 0px;
          left: 0px;
          border-radius: 0 0 0 10px;
        }
      }
      .info_sercive {
        margin-top: 17px;
        width: 100%;
        padding: 15px 24px;
        border: 1px solid #ddf1f5;
        border-radius: 6px;
        background: #f3fdff;
        .info_item:not(.info_item:last-child) {
          margin-bottom: 16px;
        }
        .info_item {
          display: flex;
          align-items: center;
          .imgIcon {
            width: 13px;
          }
          span {
            font-size: 15px;
            color: #393939;
            font-weight: 500;
            margin-left: 16px;
          }
        }
      }
    }
  }
}
</style>
